module.exports = __webpack_public_path__ + "static/higienizacja-8dd2acc2e23b4a55459ba3362ca4e5d5.svg";